import { createLightTheme, BrandVariants, Theme } from "@fluentui/react-components";

// Brand scale: 80 = Signal Blue (primary action), 60 = West-Com Navy, 40 = Deep Navy
const westComBrand: BrandVariants = {
  10:  "#010A0F",
  20:  "#031320",
  30:  "#041C30",
  40:  "#062840",  // Deep Navy
  50:  "#083350",
  60:  "#0B3D60",  // West-Com Navy
  70:  "#1C618C",
  80:  "#2E7BB8",  // Signal Blue — primary action token
  90:  "#3A90CC",
  100: "#4FB3D9",  // Sky
  110: "#72C5E3",
  120: "#95D6EC",
  130: "#B8E7F4",
  140: "#D0EFF8",
  150: "#E3F5FA",
  160: "#F0F9FD",
};

export const westComTheme: Theme = {
  ...createLightTheme(westComBrand),

  // Surfaces & backgrounds
  colorNeutralBackground1:        "#FAFBFC",  // Paper — main surface
  colorNeutralBackground2:        "#F1F5F9",  // Slate 100 — subtle card bg
  colorNeutralBackground3:        "#F1F5F9",
  colorNeutralBackground4:        "#E2E8F0",
  colorNeutralBackground5:        "#CBD5E1",
  colorNeutralBackground6:        "#CBD5E1",

  // Text
  colorNeutralForeground1:        "#0F1B26",  // Ink — primary body
  colorNeutralForeground2:        "#334155",  // Slate 700 — subdued
  colorNeutralForeground3:        "#64748B",  // Slate 500 — placeholder/hint
  colorNeutralForeground4:        "#94A3B8",  // Slate 400
  colorNeutralForegroundDisabled: "#94A3B8",

  // Borders & dividers
  colorNeutralStroke1:            "#CBD5E1",  // Slate 300
  colorNeutralStroke2:            "#E2E8F0",
  colorNeutralStroke3:            "#F1F5F9",

  // Status: Normal → Teal, Attention → Amber, Urgent → Coral
  colorStatusSuccessBackground1:  "#D1FAF6",
  colorStatusSuccessForeground1:  "#1B9E8F",  // Teal
  colorStatusSuccessForeground3:  "#147A71",
  colorStatusWarningBackground1:  "#FEF3C7",
  colorStatusWarningForeground1:  "#E8A22B",  // Amber
  colorStatusWarningForeground3:  "#B87D1E",
  colorStatusDangerBackground1:   "#FEE2E2",
  colorStatusDangerForeground1:   "#D9534F",  // Coral
  colorStatusDangerForeground3:   "#B91C1C",

  // Typography
  fontFamilyBase:      "'Manrope', 'Segoe UI', system-ui, sans-serif",
  fontFamilyMonospace: "'JetBrains Mono', 'Cascadia Code', 'Courier New', monospace",
};
